import React, { FC, useEffect, useState } from 'react';
import { classNames, useBoolState } from '../utils';
import { MaterialIcon } from './MaterialIcon';

import './NetworkStatus.scss';

const useNetworkStatus = () => {
  const [online, setOnline, setOffline] = useBoolState(navigator.onLine);
  useEffect(() => {
    window.addEventListener('online', setOnline);
    window.addEventListener('offline', setOffline);
    return () => {
      window.removeEventListener('online', setOnline);
      window.removeEventListener('offline', setOffline);
    };
  }, []);

  return online;
};

export const NetworkStatus: FC = () => {
  const [isFirstRun, setIsFirstRun] = useState(true);
  const [showOnlineMsg, setShowOnlineMsg] = useState(false);
  const online = useNetworkStatus();

  useEffect(() => {
    if (online) {
      setShowOnlineMsg(true);
    }
  }, [online]);

  useEffect(() => {
    if (!showOnlineMsg) {
      return;
    }

    if (isFirstRun) {
      setIsFirstRun(false);
      setShowOnlineMsg(false);
      return;
    }

    setTimeout(() => setShowOnlineMsg(false), 3000);
  }, [isFirstRun, showOnlineMsg]);

  if (online) {
    return null;
  }

  return (
    <>
      <div
        className={classNames(
          { 'connection-toast-show': !online },
          'connection-toast connection-offline',
        )}
      >
        <div className="connection-icon">
          <MaterialIcon name="wifi_off" type="danger" />
        </div>
        <div className="connection-text">
          <div className="connection-title">It seems like you're offline</div>
          <div>Please check your network connectivity.</div>
          <div>This message will disappear once you're back online again.</div>
        </div>
      </div>
      <div
        className={classNames(
          { 'connection-toast-show': showOnlineMsg },
          'connection-toast connection-online',
        )}
      >
        <div className="connection-icon">
          <MaterialIcon name="wifi" type="success" />
        </div>
        <div className="connection-text">
          <div className="connection-title">You're back online!</div>
        </div>
      </div>
    </>
  );
};
